/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for NiveauResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { NiveauListDTO, RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class NiveauResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    addorUpdateNiveau(niveauListDTO: NiveauListDTO, observe?: 'body', options?: RequestOptions<'blob'>): Observable<NiveauListDTO>;
    addorUpdateNiveau(niveauListDTO: NiveauListDTO, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<NiveauListDTO>>;
    addorUpdateNiveau(niveauListDTO: NiveauListDTO, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<NiveauListDTO>>;
    addorUpdateNiveau(niveauListDTO: NiveauListDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/addorUpdateNiveau`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: niveauListDTO,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveauById(idNiveau?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<NiveauListDTO>;
    getNiveauById(idNiveau?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<NiveauListDTO>>;
    getNiveauById(idNiveau?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<NiveauListDTO>>;
    getNiveauById(idNiveau?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/niveau`;

        let params = new HttpParams();
        if (idNiveau != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idNiveau, 'idNiveau');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveauById1(idNiveau?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<NiveauListDTO>;
    getNiveauById1(idNiveau?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<NiveauListDTO>>;
    getNiveauById1(idNiveau?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<NiveauListDTO>>;
    getNiveauById1(idNiveau?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/niveau`;

        let params = new HttpParams();
        if (idNiveau != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idNiveau, 'idNiveau');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveauById2(idNiveau?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<NiveauListDTO>;
    getNiveauById2(idNiveau?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<NiveauListDTO>>;
    getNiveauById2(idNiveau?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<NiveauListDTO>>;
    getNiveauById2(idNiveau?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/niveau`;

        let params = new HttpParams();
        if (idNiveau != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idNiveau, 'idNiveau');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveauById4(idNiveau?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<NiveauListDTO>;
    getNiveauById4(idNiveau?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<NiveauListDTO>>;
    getNiveauById4(idNiveau?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<NiveauListDTO>>;
    getNiveauById4(idNiveau?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/niveau`;

        let params = new HttpParams();
        if (idNiveau != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idNiveau, 'idNiveau');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveauById3(idNiveau?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<NiveauListDTO>;
    getNiveauById3(idNiveau?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<NiveauListDTO>>;
    getNiveauById3(idNiveau?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<NiveauListDTO>>;
    getNiveauById3(idNiveau?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/niveau`;

        let params = new HttpParams();
        if (idNiveau != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idNiveau, 'idNiveau');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveauById6(idNiveau?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<NiveauListDTO>;
    getNiveauById6(idNiveau?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<NiveauListDTO>>;
    getNiveauById6(idNiveau?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<NiveauListDTO>>;
    getNiveauById6(idNiveau?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/niveau`;

        let params = new HttpParams();
        if (idNiveau != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idNiveau, 'idNiveau');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveauById5(idNiveau?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<NiveauListDTO>;
    getNiveauById5(idNiveau?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<NiveauListDTO>>;
    getNiveauById5(idNiveau?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<NiveauListDTO>>;
    getNiveauById5(idNiveau?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/niveau`;

        let params = new HttpParams();
        if (idNiveau != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idNiveau, 'idNiveau');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveau(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NiveauListDTO>>;
    getNiveau(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NiveauListDTO>>>;
    getNiveau(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NiveauListDTO>>>;
    getNiveau(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-niveaux`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveau1(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NiveauListDTO>>;
    getNiveau1(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NiveauListDTO>>>;
    getNiveau1(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NiveauListDTO>>>;
    getNiveau1(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-niveaux`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveau2(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NiveauListDTO>>;
    getNiveau2(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NiveauListDTO>>>;
    getNiveau2(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NiveauListDTO>>>;
    getNiveau2(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-niveaux`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveau4(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NiveauListDTO>>;
    getNiveau4(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NiveauListDTO>>>;
    getNiveau4(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NiveauListDTO>>>;
    getNiveau4(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-niveaux`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveau3(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NiveauListDTO>>;
    getNiveau3(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NiveauListDTO>>>;
    getNiveau3(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NiveauListDTO>>>;
    getNiveau3(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-niveaux`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveau6(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NiveauListDTO>>;
    getNiveau6(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NiveauListDTO>>>;
    getNiveau6(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NiveauListDTO>>>;
    getNiveau6(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-niveaux`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getNiveau5(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NiveauListDTO>>;
    getNiveau5(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NiveauListDTO>>>;
    getNiveau5(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NiveauListDTO>>>;
    getNiveau5(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-niveaux`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
